import React, {Component} from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import BranchSearchForm from '../branchSelector/BranchSearchForm';

export default class BranchPicker extends Component {
    state = {
        open: false,
    };

    handleOpen = () => {
        this.setState({open: true});
        this.props.resetSearch();
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleClose}
            />
        ];

        return (
            <div style={{textAlign: 'right'}}>
                <RaisedButton label="Add User Access" onTouchTap={this.handleOpen}/>
                <Dialog
                    title="Add user access"
                    actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                    autoScrollBodyContent={true}>
                    <BranchSearchForm filter={this.props.filter} onAddButtonClicked={(useraccess)=>{this.props.onUserAccessAddClicked(useraccess); this.handleClose()}}/>
                </Dialog>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/branchSelector/BranchPicker.js